import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { setUserSeries } from "@/lib/catalogue";
import { setUserDetails } from "@/lib/details";
import { getLibrary, setLibrary } from "@/lib/iwin";
import { useAuth } from "@/context/AuthContext";

const Ctx = createContext({ catalogues: [], reload: () => {}, version: 0 });

export const CatalogueProvider = ({ children }) => {
  const { user } = useAuth();
  const [catalogues, setCatalogues] = useState([]);
  const [version, setVersion] = useState(0);
  const reload = useCallback(async () => {
    if (!getLibrary()) setLibrary((await api.get("/library")).data);
    const { data } = await api.get("/catalogues");
    setUserSeries(data.filter((c) => c.status === "ready").flatMap((c) => c.series));
    setUserDetails(data.flatMap((c) => (c.details || []).map((d) => ({ ...d, catalogue_id: c.catalogue_id, catalogue_name: c.filename }))));
    setCatalogues(data);
    setVersion((v) => v + 1);
    return data;
  }, []);
  useEffect(() => { if (user) reload().catch(() => {}); }, [user, reload]);
  useEffect(() => {
    if (!catalogues.some((c) => c.status === "processing" || c.shapes_status === "processing" || c.details_status === "processing")) return;
    const t = setInterval(() => reload().catch(() => {}), 5000);
    return () => clearInterval(t);
  }, [catalogues, reload]);
  return <Ctx.Provider value={{ catalogues, reload, version }}>{children}</Ctx.Provider>;
};

export const useCatalogues = () => useContext(Ctx);
